import { useEffect, useState } from 'react';
import { adminApi } from '../../../services/adminApi';

interface AppLogRow {
  id: string;
  level: string;
  category: string;
  message: string;
  details: any;
  userId: string | null;
  gameId: string | null;
  createdAt: string;
}

export default function LogsTab() {
  const [logs, setLogs] = useState<AppLogRow[]>([]);
  const [level, setLevel] = useState<string>('');
  const [category, setCategory] = useState<string>('');
  const [loading, setLoading] = useState(false);

  async function refresh() {
    setLoading(true);
    try {
      const res = await adminApi.get('/logs', {
        params: { level: level || undefined, category: category || undefined, limit: 100 },
      });
      setLogs(res.data.logs);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [level, category]);

  return (
    <div>
      <div className="flex gap-3 mb-4 flex-wrap">
        <select
          value={level}
          onChange={(e) => setLevel(e.target.value)}
          className="px-3 py-2 bg-black/30 border border-white/10 rounded-lg text-sm"
        >
          <option value="">All levels</option>
          <option value="error">error</option>
          <option value="warn">warn</option>
          <option value="info">info</option>
        </select>
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="px-3 py-2 bg-black/30 border border-white/10 rounded-lg text-sm"
        >
          <option value="">All categories</option>
          <option value="action">action</option>
          <option value="game">game</option>
          <option value="auth">auth</option>
          <option value="system">system</option>
        </select>
        <button
          onClick={refresh}
          className="px-3 py-2 text-sm bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg"
        >
          {loading ? '\u2026' : 'Refresh'}
        </button>
      </div>

      <div className="space-y-1 font-mono text-xs">
        {logs.map((l) => (
          <div
            key={l.id}
            className={`bg-white/5 border border-white/10 rounded px-3 py-2 ${
              l.level === 'error'
                ? 'border-l-4 border-l-red-500'
                : l.level === 'warn'
                  ? 'border-l-4 border-l-amber-500'
                  : 'border-l-4 border-l-white/20'
            }`}
          >
            <div className="flex items-center gap-2 text-gray-400">
              <span>{new Date(l.createdAt).toLocaleString()}</span>
              <span className="uppercase">{l.level}</span>
              <span>[{l.category}]</span>
            </div>
            <div className="text-white">{l.message}</div>
            {l.details && (
              <pre className="mt-1 text-gray-400 whitespace-pre-wrap break-all">
                {JSON.stringify(l.details, null, 0)}
              </pre>
            )}
          </div>
        ))}
        {logs.length === 0 && !loading && (
          <div className="text-center text-gray-400 py-8">No logs.</div>
        )}
      </div>
    </div>
  );
}
